import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './LockBar.scss';
import { useTranslation } from 'react-i18next';
import { AmountOfTotal, DropdownItem } from 'shared/components';
import LockBlue from 'assets/svgs/lockBlue.svg';
import LockGray from 'assets/svgs/lockGray.svg';
import UnlockBlue from 'assets/svgs/unlockBlue.svg';
import UnlockGray from 'assets/svgs/unlockGray.svg';
import ChevronDown from 'assets/svgs/chevronDown.svg';
import OnlineTestingService from '../OnlineTestingService';
import { useDispatch } from 'react-redux';
import * as onlineTestingActions from '../duck';
import { WKYS_EXAMINEE_TYPES } from 'shared/constants';

const LockBar = (props) => {
  const { t } = useTranslation();
  const {
    isNCRCRoom,
    onlineRegs,
    regTypes,
    roomId,
    selectedAssessmentTab
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const getLockedExaminees = (lockedStatus) => onlineRegs.every((reg) => reg.locked === lockedStatus);
  const ref = React.createRef();

  const lockedExaminees = onlineRegs.filter((examinee) => examinee.locked);
  const allLocked = getLockedExaminees(true);
  const allUnlocked = getLockedExaminees(false);

  const statusNotReady = onlineRegs.every((reg) => reg.testStatus === null || reg.testStatus === '');

  const disabledClass = statusNotReady ? 'disabled' : '';

  const handleClickOutside = (event) => {
    if (ref && ref !== null) {
      const cur = ref.current;
      if (cur && !cur.contains(event.target)) {
        setIsOpen(false);
      }
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  });

  const handleLockUnlock = async (lockedStatus) => {
    const data = onlineRegs.map((reg) => ({
      regId: reg.id,
      locked: lockedStatus,
    }));
    await OnlineTestingService.putLockedRegs(data);
    
    // For NCRC rooms, passing regTypeId to fetch filtered data
    let regTypeId = null;
    if (isNCRCRoom && regTypes?.length > 0) {
      const assessmentCodes = Object.entries(WKYS_EXAMINEE_TYPES)
        .filter(([code]) => code !== 'ncrc')
        .map(([code]) => code);
      const assessment = assessmentCodes[selectedAssessmentTab - 1];
      const regType = regTypes.find((rt) => rt.code === assessment?.toUpperCase());
      regTypeId = regType?.id || null;
    }
    
    dispatch(onlineTestingActions.getOnlineRegs(roomId, regTypeId));
  };

  const handleOpenDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="lock-bar-container">
      <AmountOfTotal
        label="Locked"
        total={onlineRegs.length}
        nrOfTotal={lockedExaminees.length}
      />

      {allLocked &&
      <div className={`lock-bar  ${disabledClass}`} onClick={() => handleLockUnlock(false)}>
        <div className="unlock">{t('onlineTesting.lockUnlock.unlockAll')}</div>
        {statusNotReady ? <UnlockGray/> : <UnlockBlue/>}
      </div>}
      {allUnlocked &&
      <div className={`lock-bar  ${disabledClass}`} onClick={() => handleLockUnlock(true)}>
        <div className="unlock">{t('onlineTesting.lockUnlock.lockAll')}</div>
        {statusNotReady ? <LockGray/> : <LockBlue/>}
      </div>}
      {!allLocked && !allUnlocked &&
      <div className={`lock-bar  ${disabledClass}`} onClick={handleOpenDropdown} ref={ref}>
        <div className="unlock">{t('onlineTesting.lockUnlock.lockUnlock')}</div>
        <div>
          <ChevronDown/>
        </div>
        {isOpen && <div className="lock-dropdown">
          <DropdownItem handleClick={() => handleLockUnlock(true)} icon={<LockBlue/>}
                        text={t('onlineTesting.lockUnlock.lockAll')}/>
          <div className="separator"></div>
          <DropdownItem handleClick={() => handleLockUnlock(false)} icon={<UnlockBlue/>}
                        text={t('onlineTesting.lockUnlock.unlockAll')}/>
        </div>}
      </div>}
    </div>
  );
};

export default LockBar;

LockBar.propTypes = {
  isNCRCRoom: PropTypes.bool,
  onlineRegs: PropTypes.array.isRequired,
  regTypes: PropTypes.array,
  roomId: PropTypes.string.isRequired,
  selectedAssessmentTab: PropTypes.number,
};

LockBar.defaultProps = {
  isNCRCRoom: false,
  regTypes: [],
  selectedAssessmentTab: 1,
};
